const FORWARDLINK = "/drive/get_by_id";

export const forwardLink = { FORWARDLINK };
